var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5706 7.14844H15.4924V4.5C15.4924 4.08516 15.1529 3.75 14.7327 3.75H5.04565V2.8125C5.04565 2.70937 4.96018 2.625 4.85571 2.625H3.52612C3.42166 2.625 3.33618 2.70937 3.33618 2.8125V21.1875C3.33618 21.2906 3.42166 21.375 3.52612 21.375H4.85571C4.96018 21.375 5.04565 21.2906 5.04565 21.1875V15H10.9338V17.6484C10.9338 18.0633 11.2734 18.3984 11.6936 18.3984H21.5706C21.9908 18.3984 22.3303 18.0633 22.3303 17.6484V7.89844C22.3303 7.48359 21.9908 7.14844 21.5706 7.14844ZM5.04565 13.3125V5.4375H13.783V13.3125H5.04565ZM20.6208 16.7109H12.6433V15H15.3025C15.407 15 15.4924 14.9156 15.4924 14.8125V8.83594H20.6208V16.7109Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTag);
export default __webpack_public_path__ + "static/media/card-tag.d0f3e1e8edea81e1f2d0a27950de61f2.svg";
export { ForwardRef as ReactComponent };